export default __webpack_public_path__ + "static/media/mobile_dashboard.fe8cdbc2.png";